import React from 'react';
import { Outlet } from 'react-router-dom';
import { APP_PAGE_BLEED_ROOT, APP_PAGE_GUTTER } from '../../utils/sessionMobileLayout';

/**
 * ProfileLayout - Player Hub layout
 * Clean wrapper — no top nav; the hub overview is the single entry point.
 * Sub-pages (clubs, games, settings) are reached from the Explore cards.
 */
const ProfileLayout = ({ currentUser }) => {
  return (
    <div className={APP_PAGE_BLEED_ROOT}>
      <div className={`max-w-app-shell mx-auto ${APP_PAGE_GUTTER} py-4`}>
        <div className="profile-content">
          <Outlet context={{ currentUser }} />
        </div>
      </div>
    </div>
  );
};

export default ProfileLayout;

